module.exports = __webpack_public_path__ + "img/API.75aafadf.png";